import { Stack } from "@mui/material";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { type QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import Header from "@/components/Page/Header";

interface RouterContext {
  queryClient: QueryClient;
  getTitle?: () => string;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <Stack sx={{ height: "100vh", overflow: "hidden" }}>
      <Header />
      <Outlet />
      {import.meta.env.DEV && (
        <TanStackDevtools
          config={{ position: "bottom-left", panelLocation: "bottom" }}
          plugins={[
            {
              name: "TanStack Query",
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: "TanStack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      )}
    </Stack>
  );
}
